import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <section className="min-h-[70vh] bg-cream flex items-center justify-center px-5 py-24" data-testid="payment-cancel">
      <div className="max-w-lg w-full rounded-3xl border border-navy/10 bg-white p-10 text-center shadow-sm">
        <XCircle size={56} className="mx-auto text-anthracite/50" />
        <h1 className="mt-6 font-display text-3xl text-navy">Paiement annulé</h1>
        <p className="mt-3 text-anthracite font-body">
          Le paiement a été annulé — aucune somme n'a été prélevée. Votre facture reste ouverte, vous pouvez la régler à tout moment depuis votre espace client.
        </p>
        <Link to="/espace-client" data-testid="back-to-portal" className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3 font-semibold text-white hover:bg-navy/90 transition-colors">
          Retour aux factures <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}
